import { CountingFrom, Plan, TirePressureUnit } from "../http/onlyclicksApi";
import { Step } from "../pages/Garage/NewBikePage";

const en = {
  fork: "Fork",
  sag: "Sag",
  air_pressure: "Air Pressure",
  negative_air_pressure: (short: boolean) =>
    short ? "Neg. Air Pressure" : "Negative Air Pressure",
  bar: "Bar",
  psi: "PSI",
  spring_weight: "Spring weight",
  lbs: "LBS",
  lsc: (short: boolean) => (short ? "LSC" : "Low Speed Compression"),
  hsc: (short: boolean) => (short ? "HSC" : "High Speed Compression"),
  lsr: (hasHighSpeedRebound: boolean, short: boolean) =>
    hasHighSpeedRebound ? (short ? "LSR" : "Low Speed Rebound") : "Rebound",
  hsr: (short: boolean) => (short ? "HSR" : "High Speed Rebound"),
  volume_spacers: "Volume Spacers",
  clicks: "Clicks",
  quantity: "Quantity",
  front_pressure: "Front Pressure",
  front: "Front",
  rear_pressure: "Rear Pressure",
  rear: "Rear",
  shock: "Shock",
  wheels: "Wheels",
  notes: "Notes",
  countingFrom: (countingFrom: CountingFrom) => {
    switch (countingFrom) {
      case "fully_closed":
        return "Fully Closed";
      case "fully_open":
        return "Fully Open";
    }
  },
  tirePressureUnit: (unit: TirePressureUnit) => {
    switch (unit) {
      case "bar":
        return en.bar;
      case "psi":
        return en.psi;
    }
  },
  stepTitle: (step: Step) => {
    switch (step) {
      case Step.Bike:
        return "Bike";
      case Step.Fork:
        return "Fork";
      case Step.Shock:
        return "Shock";
      case Step.Wheels:
        return "Wheels";
    }
  },
  name: "Name",
  plan: (plan: Plan) => {
    switch (plan) {
      case Plan.Free:
        return "Free";
      case Plan.Paid:
        return "Paid";
    }
  },
};

export default en;
